export enum ImageFormats {
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  GIF = 'image/gif',
}

export enum VideoFormats {
  MP4 = 'video/mp4',
  WEBM = 'video/webm',
  OGG = 'video/ogg',
  FLV = 'video/x-flv',
  AVI = 'video/avi,video/x-msvideo',
  WMV = 'video/x-ms-wmv',
  MPG = 'video/mpeg',
  MPEG = 'video/mpeg',
  M4V = 'video/x-m4v',
  MKV = 'video/x-matroska',
  MOV = 'video/quicktime',
}

export enum AudioFormats {
  MP3 = 'audio/mpeg',
  AU = 'audio/basic',
  WMA = 'audio/x-ms-wma',
  WAV = 'audio/wav',
  OGG = 'audio/ogg',
  AAC = 'audio/aac,audio/vnd.dlna.adts',
}

export enum DocumentFormats {
  PDF = 'application/pdf',
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  XLS = 'application/vnd.ms-excel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  MSWORD = 'application/msword',
  OPENXML_DOC = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  OPENXML_XLS = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  MS_EXCEL = 'application/vnd.ms-excel',
}

export const validExtensions = [
  'jpg',
  'jpeg',
  'png',
  'jfif',
  'gif',
  'mp4',
  'webm',
  'ogg',
  'flv',
  'avi',
  'wmv',
  'mpg',
  'mpeg',
  'm4v',
  'mkv',
  'mov',
  'mp3',
  'au',
  'aac',
  'wma',
  'wav',
  'pdf',
  'doc',
  'docx',
  'xls',
  'text',
  'xlsx',
  'msword',
  'openxml_doc',
  'openxml_xls',
  'ms_excel',
];
